export default __webpack_public_path__ + "static/media/_LoginBG_Image.f64b1ad6.png";